import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { MenuItem } from 'primeng/api';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ManagerComponent as GroupsManagerPage } from 'src/app/components/groups/manager/manager.component';
import { CreatePage as ClientRolesCreate } from 'src/app/clients/roles/create/create.page';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';
import { SelectPage as TeamMembersSelectPage } from 'src/app/team-members/select/select.page';
import * as dayjs from 'dayjs';
import { CustomFieldsService, CustomFieldDef } from 'src/app/api/custom-fields.service';
import { ManageComponent as ManageCustomFieldsComponent } from 'src/app/components/custom-fields/manage/manage.component';


@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {

  company = {
    is_a_client: true,
    name: '',
    description: '',
    phone_number: '',
    fax: '',
    website: '',
    str_address_1: '',
    str_address_2: '',
    city: '',
    province: '',
    postal_code: '',
    country: '',
    clients: [],
    tags: [],
    groups: [],
    team_members: [],
    corp_name: '',
    custom_id: '',
    custom_data: '',
    business_number: '',
    industry: '',
    type: '',
    default_client_guid: '',
    client_groups: [],
    all_team_members: true,
    year_end_month: '12',
    year_end_day: '31',
    year_end_date: `${new Date().getFullYear()}-12-31`
  }
  @Input() groups = [];
  @Input() is_a_client = null;

  unassigned_clients = [];
  unassigned_team_members = [];
  items: MenuItem[];
  activeIndex = 0;

  add_tag = {
    title: '',
    colour: '#90ee90'
  }

  team_member_roles = [];
  clients_roles = [];
  availableDays: number[] = [];
  detailsIndex = 'details';
  firmFieldDefs: CustomFieldDef[] = [];

  constructor(private apiService: ApiService, private modalController: ModalController, public globalService: GlobalService, private alertController: AlertController, private customFieldsService: CustomFieldsService) { }

  ngOnInit() {
    if (this.groups.length > 0) this.company.groups = this.groups;
    if (this.is_a_client != null) this.company.is_a_client = this.is_a_client;
    this.items = [
      { label: 'Basic Information' },
      { label: 'Details' },
      { label: 'Assignments' },
      { label: 'Review' }
    ];
    this.GetClientsRolesAndMembers();
    this.GetRolesAndMembers();
    this.GetAllGroups();
    this.GetAllTags();
    this.MergeFirmCustomFields();
    if (this.company.year_end_date) {
      const yearEndDate = dayjs(this.company.year_end_date);
      this.company.year_end_month = yearEndDate.format('MM');
      this.company.year_end_day = yearEndDate.format('DD');
      this.updateAvailableDays(); // Populate day options based on month
    }
  }

  //Creat ethe company
  async Create() {
    // Ask about any field added via addField() this session, before the loading overlay starts, so
    // its alert doesn't stack on top of it - mirrors UpdateBasicInfo() in companies/details.
    this.firmFieldDefs = await this.customFieldsService.PromptAndSaveNewFieldScopes('companies', this.customFields);
    await this.globalService.presentLoading('Creating Company', 99999999);
    let data: any = await this.apiService.post('companies', this.company);
    console.log("COMPABNY DATA", data);
    this.globalService.dismissLoading();
    if (data.success) {
      await this.globalService.presentLoading('Updating Details', 99999999);
      this.customFieldsService.AssignFieldIds(this.customFields);
      this.company.custom_data = JSON.stringify(this.customFields);
      let data2: any = await this.apiService.put(`companies/${data.data[0].guid}`, this.company);
      this.globalService.dismissLoading();
      this.globalService.presentToastMessage(data.message, data.success);
      this.modalController.dismiss(data.data[0]);
    }
  }

  //Get a list of firm clients
  async GetClients() {
    let data: any = await this.apiService.GetClients();;
    if (data.success) {
      console.log(data);
      if (!data.data) data.data = [];
      this.unassigned_clients = data.data;
      for (let i = 0; i < this.unassigned_clients.length; i++) {
        this.unassigned_clients[i].role_guid = this.clients_roles[0].guid;
      }
    }
  }

  //Get roles and members. Imporant its in order
  async GetRolesAndMembers() {
    await this.GetTeamRoles();
    this.GetTeamMembers();
  }

  async GetClientsRolesAndMembers() {
    await this.GetClientsRoles();
    this.GetClients();
  }

  //Get a list of firm team_member
  async GetTeamMembers() {
    let data: any = await this.apiService.get('team_members');
    if (data.success) {
      this.unassigned_team_members = data.data;
      for (let i = 0; i < this.unassigned_team_members.length; i++) {
        this.unassigned_team_members[i].role_guid = this.team_member_roles[0].guid;
      }

    }
  }

  //Return the list of team member roles
  async GetTeamRoles() {
    let data: any = await this.apiService.get('firms/team_members/roles');
    if (data.success) {
      this.team_member_roles = data.data;
    }
  }

  async GetClientsRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) {
      this.clients_roles = data.data;
    }
  }

  async Close() {
    const isDirty = this.company.name?.trim() || this.company.clients?.length > 0
      || this.company.team_members?.length > 0;
    if (isDirty) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You have unsaved changes. If you cancel now, your work will be lost.',
        buttons: [
          { text: 'Keep Editing', role: 'cancel' },
          { text: 'Discard', role: 'destructive', handler: () => this.modalController.dismiss(null) }
        ]
      });
      await alert.present();
    } else {
      this.modalController.dismiss(null);
    }
  }

  //Change steps
  async GoToStep(step) {
    this.activeIndex = step;
  }

  //Prompt to quickly create a client
  async PresentCreateClient() {

  }


  //When finished everything create the company

  // Typeahead for Groups/Tags (same pattern as the project create page) - the "+" modals stay for bulk
  // selection or creating a brand new one, and reload these lists when they close so anything created
  // there is searchable straight away.
  all_groups: any[] = [];
  group_search_query = '';
  group_suggestions: any[] = [];
  group_suggestions_active_index = -1;
  show_group_suggestions = false;

  all_tags: any[] = [];
  tag_search_query = '';
  tag_suggestions: any[] = [];
  tag_suggestions_active_index = -1;
  show_tag_suggestions = false;

  async GetAllGroups() {
    const data: any = await this.apiService.GetGroups('companies');
    this.all_groups = data?.data || [];
  }

  async GetAllTags() {
    const data: any = await this.apiService.GetTags('companies');
    this.all_tags = data?.data || [];
  }

  OnGroupSearchChange() {
    const q = (this.group_search_query || '').trim().toLowerCase();
    this.group_suggestions_active_index = -1;
    if (!q || !this.all_groups?.length) {
      this.group_suggestions = [];
      this.show_group_suggestions = false;
      return;
    }
    const selectedGuids = new Set((this.company.groups || []).map((g: any) => g.guid));
    this.group_suggestions = this.all_groups
      .filter((g: any) => !selectedGuids.has(g.guid) && (g.title || '').toLowerCase().includes(q))
      .slice(0, 15);
    this.show_group_suggestions = this.group_suggestions.length > 0;
  }

  OnGroupInputFocus() {
    if (this.group_search_query) this.OnGroupSearchChange();
  }

  OnGroupInputBlur() {
    this.show_group_suggestions = false;
  }

  OnGroupInputKeydown(event: KeyboardEvent) {
    if (!this.show_group_suggestions || this.group_suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.group_suggestions_active_index = Math.min(this.group_suggestions_active_index + 1, this.group_suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.group_suggestions_active_index = Math.max(this.group_suggestions_active_index - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.group_suggestions_active_index >= 0 ? this.group_suggestions_active_index : 0;
      this.SelectGroupSuggestion(this.group_suggestions[index]);
    } else if (event.key === 'Escape') {
      this.show_group_suggestions = false;
    }
  }

  SelectGroupSuggestion(group: any) {
    if (!group?.guid) return;
    if (!(this.company.groups || []).some((g: any) => g.guid === group.guid)) {
      this.company.groups = [...(this.company.groups || []), group];
    }
    this.ClearGroupSearchState();
  }

  private ClearGroupSearchState() {
    this.group_search_query = '';
    this.group_suggestions = [];
    this.group_suggestions_active_index = -1;
    this.show_group_suggestions = false;
  }

  OnTagSearchChange() {
    const q = (this.tag_search_query || '').trim().toLowerCase();
    this.tag_suggestions_active_index = -1;
    if (!q || !this.all_tags?.length) {
      this.tag_suggestions = [];
      this.show_tag_suggestions = false;
      return;
    }
    const selectedGuids = new Set((this.company.tags || []).map((t: any) => t.guid));
    this.tag_suggestions = this.all_tags
      .filter((t: any) => !selectedGuids.has(t.guid) && (t.title || '').toLowerCase().includes(q))
      .slice(0, 15);
    this.show_tag_suggestions = this.tag_suggestions.length > 0;
  }

  OnTagInputFocus() {
    if (this.tag_search_query) this.OnTagSearchChange();
  }

  OnTagInputBlur() {
    this.show_tag_suggestions = false;
  }

  OnTagInputKeydown(event: KeyboardEvent) {
    if (!this.show_tag_suggestions || this.tag_suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.tag_suggestions_active_index = Math.min(this.tag_suggestions_active_index + 1, this.tag_suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.tag_suggestions_active_index = Math.max(this.tag_suggestions_active_index - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.tag_suggestions_active_index >= 0 ? this.tag_suggestions_active_index : 0;
      this.SelectTagSuggestion(this.tag_suggestions[index]);
    } else if (event.key === 'Escape') {
      this.show_tag_suggestions = false;
    }
  }

  SelectTagSuggestion(tag: any) {
    if (!tag?.guid) return;
    if (!(this.company.tags || []).some((t: any) => t.guid === tag.guid)) {
      this.company.tags = [...(this.company.tags || []), tag];
    }
    this.ClearTagSearchState();
  }

  private ClearTagSearchState() {
    this.tag_search_query = '';
    this.tag_suggestions = [];
    this.tag_suggestions_active_index = -1;
    this.show_tag_suggestions = false;
  }

  //Remove from arrays
  async RemoveTag(tag) {
    this.globalService.RemoveFromArray(this.company.tags, tag.guid);
  }
  async RemoveGroup(group) {
    this.globalService.RemoveFromArray(this.company.groups, group.guid);
  }
  async RemoveClient(client) {
    this.globalService.RemoveFromArray(this.company.clients, client.guid);
  }
  async RemoveTeamMember(team_member) {
    this.globalService.RemoveFromArray(this.company.team_members, team_member.guid);
  }

  //Google API logic
  //Sets the company address automatically
  handleAddressChange(address: Address) {
    this.company.str_address_1 = address.formatted_address;
    this.company.city = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['locality', 'political']))[0].long_name;
    this.company.province = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['administrative_area_level_1', 'political']))[0].long_name;
    this.company.country = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['country', 'political']))[0].long_name;
    this.company.postal_code = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['postal_code']))[0].long_name;
  }

  //Returns the text value of the employee type
  GetEmployeeTypeText(guid) {
    let i = this.globalService.GetArrayIndex(this.team_member_roles, guid);
    if (i == -1)
      return "No Role";
    else
      return this.team_member_roles[i].title;
  }
  //Returns the colour of the employee tpe
  GetEmployeeTypeColour(guid) {
    let i = this.globalService.GetArrayIndex(this.team_member_roles, guid);
    if (i == -1)
      return "light-blue";
    else
      return this.team_member_roles[i].colour;
  }

  //Returns the text value of the employee type
  GetClientTypeText(guid) {
    let i = this.globalService.GetArrayIndex(this.clients_roles, guid);
    if (i == -1)
      return "No Role";
    else
      return this.clients_roles[i].title;
  }
  //Returns the colour of the employee tpe
  GetClientTypeColour(guid) {
    let i = this.clients_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "light-blue";
    else
      return this.clients_roles[i].colour;
  }

  // Assigned contacts grouped under a heading per role, so the badges are easier to scan than one
  // long flat list - "No Role" is always last, everything else alphabetical by role title.
  get clientsByRole(): { role_guid: string; title: string; colour: string; clients: any[] }[] {
    if (!this.company.clients || this.company.clients.length === 0) return [];
    const groups: { role_guid: string; title: string; colour: string; clients: any[] }[] = [];
    for (const client of this.company.clients) {
      const role_guid = client.role_guid || '';
      let group = groups.find(g => g.role_guid === role_guid);
      if (!group) {
        group = { role_guid, title: this.GetClientTypeText(role_guid), colour: this.GetClientTypeColour(role_guid), clients: [] };
        groups.push(group);
      }
      group.clients.push(client);
    }
    groups.sort((a, b) => a.role_guid === '' ? 1 : b.role_guid === '' ? -1 : a.title.localeCompare(b.title));
    const default_client = this.company.clients.find((c: any) => c.guid === this.company.default_client_guid);
    if (default_client) {
      groups.unshift({ role_guid: '__default__', title: 'Default Contact', colour: '#FFD700', clients: [default_client] });
    }
    return groups;
  }

  async presentSelectClientsModal() {
    let company_clients_copy = JSON.stringify(this.company.clients);
    const modal = await this.modalController.create({
      component: ContactsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        company: this.company,
        selecting_for_company: true,
        hide_companies: true,
        selected_clients: this.company.clients,
        remove_clients: this.company.clients,
        in_clients: [],
        target_header: 'Currently Selected',
        selecting_for_default: true,
        default_client_guid: this.company.default_client_guid
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data.clients) {
        console.log(data.data);
        this.company.clients = data.data.clients;
        let default_client = this.company.clients.find((c: any) => c.default_for_company);
        this.company.default_client_guid = default_client ? default_client.guid : '';
      }
      else {
        this.company.clients = JSON.parse(company_clients_copy);
      }
    });
    return await modal.present()
  }

  async presentSelectTeamMembersModal() {
    let company_team_members_copy = JSON.stringify(this.company.team_members);
    const modal = await this.modalController.create({
      component: TeamMembersSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        company: this.company,
        selecting_for_company: true,
        selected_team_members: this.company.team_members,
        remove_team_members: this.company.team_members,
        in_team_members: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        this.company.team_members = data.data;
      }
      else {
        this.company.team_members = JSON.parse(company_team_members_copy);
      }
    });
    return await modal.present()
  }


  //COMPANY GROUPS
  async presentSelectGroupsModal() {
    const modal = await this.modalController.create({
      component: GroupsManagerPage,
      cssClass: 'medium-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'companies',
        selection_mode: true,
        max_selection: 999,
        selected_groups: [...this.company.groups],
        modal_title: 'Select Groups'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      // A group may have been created in the modal - reload the list the group search box works from
      this.GetAllGroups();
      if (data && data.data) {
        this.company.groups = data.data;
      }
    });
    return await modal.present();
  }


  //TAGS
  //Present the modal to select tags to apply to the company
  async presentSelectTagsModal() {
    let company_tags_copy = JSON.stringify(this.company.tags);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'companies',
        selected_tags: this.company.tags
      }
    })
    modal.onDidDismiss().then((data: any) => {
      // A tag may have been created in the modal - reload the list the tag search box works from
      this.GetAllTags();

      if (data && data.data) {
        company_tags_copy = JSON.parse(company_tags_copy);
      }
      else {
        this.company.tags = [...JSON.parse(company_tags_copy)];
      }
    });
    return await modal.present()
  }

  async presentClientRolesCreateModal() {
    const modal = await this.modalController.create({
      component: ClientRolesCreate,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {

      }
    })
    modal.onDidDismiss().then((data: any) => {
      this.GetClientsRoles();

    });
    return await modal.present()

  }

  error_message = '';
  has_error = false;

  ngDoCheck() {
    this.CheckIfFormIsValid();
  }

  CheckIfFormIsValid() {
    this.error_message = '';
    let has_error = false;
    const messages: string[] = [];


    // Company name required
    if (this.company.name.trim() === '') {
      messages.push('Company name is required.');
      has_error = true;
    }

    // At least one client required
    if (!this.company.clients || this.company.clients.length == 0) {
      messages.push('At least one contact must be assigned to the company.');
      has_error = true;
    }

    // Default client required
    if (!this.company.default_client_guid || this.company.default_client_guid.trim() === '') {
      messages.push('A default contact must be selected for the company.');
      has_error = true;
    }

    // At least one team member required
    if ((!this.company.team_members || this.company.team_members.length == 0) && !this.company.all_team_members) {
      messages.push('At least one team member must be assigned to the company.');
      has_error = true;
    }

    // Write to string for tooltip or display
    this.error_message = messages.join('<br>');
    this.has_error = has_error;
  }

  updateAvailableDays() {
    if (!this.company.year_end_month) {
      this.availableDays = [];
      return;
    }

    const month = parseInt(this.company.year_end_month, 10);
    const currentYear = new Date().getFullYear();

    // Get the number of days in the selected month
    // Using current year to determine leap year status
    const daysInMonth = new Date(currentYear, month, 0).getDate();

    // Generate array from 1 to daysInMonth
    this.availableDays = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    // Update year_end_date when month changes
    this.updateYearEndDate();
  }

  updateYearEndDate() {
    if (!this.company.year_end_month || !this.company.year_end_day) {
      return;
    }

    const currentYear = new Date().getFullYear();
    const month = this.company.year_end_month.padStart(2, '0');
    const day = this.company.year_end_day.padStart(2, '0');

    this.company.year_end_date = `${currentYear}-${month}-${day}`;
  }

  async GoToStepDetails(step) {
    this.detailsIndex = step;
  }

   customFields: { name: string; type: string; value: any; _is_new?: boolean }[] = [];

addField() {
  this.customFields.push({
    name: '',
    type: 'text',
    value: '',
    _is_new: true
  });
}

removeField(index: number) {
  this.customFields.splice(index, 1);
}

// Firm-wide custom field definitions (Manage Firm > Companies) that aren't already present here get
// added with a blank value - see CustomFieldsService.MergeFieldDefsInto.
async MergeFirmCustomFields() {
  const defs = await this.customFieldsService.GetFieldDefs();
  this.firmFieldDefs = defs.companies;
  this.customFieldsService.MergeFieldDefsInto(this.customFields, defs.companies, defs.loaded, defs.deleted_companies);
}

IsGlobalField(field: any): boolean {
  return this.firmFieldDefs?.some(d => d.name === field.name) ?? false;
}

async OpenManageGlobalCustomFields() {
  const modal = await this.modalController.create({
    component: ManageCustomFieldsComponent,
    cssClass: 'tall-modal medium-modal secondary-modal',
    backdropDismiss: false,
    componentProps: { entity_type: 'companies' },
  });
  modal.onDidDismiss().then(async (data: any) => {
    if (data?.data?.saved) await this.MergeFirmCustomFields();
  });
  return await modal.present();
}




}
